var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 127,
    viewBox: "0 0 98 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0608 10.5063C62.9293 10.1019 62.5797 9.80736 62.1589 9.74626L53.478 8.48721L49.5938 0.622378C49.4056 0.241267 49.0174 0 48.5923 0H48.592C48.1667 0.000111697 47.7786 0.241601 47.5905 0.622936L43.7106 8.48989L35.0303 9.75352C34.6097 9.81473 34.2602 10.1096 34.1288 10.514C33.9976 10.9184 34.1072 11.3623 34.4118 11.659L40.6947 17.7801L39.2142 26.426C39.1424 26.845 39.3147 27.2686 39.6587 27.5183C39.8533 27.6595 40.0836 27.7314 40.3152 27.7314C40.4931 27.7314 40.6717 27.689 40.8351 27.603L48.5982 23.519L56.3635 27.5987C56.7399 27.7964 57.1958 27.7634 57.5398 27.5134C57.8838 27.2634 58.056 26.8399 57.9839 26.4208L56.4988 17.7757L62.7785 11.6514C63.0828 11.3545 63.1923 10.9106 63.0608 10.5063ZM54.5186 16.5865C54.2556 16.8432 54.1354 17.213 54.1977 17.5754L55.3991 24.5686L49.1176 21.2683C48.7922 21.0974 48.4035 21.0975 48.0779 21.2686L41.7981 24.5722L42.9958 17.5783C43.0579 17.2158 42.9376 16.8462 42.6743 16.5896L37.5918 11.6381L44.6135 10.6159C44.9773 10.563 45.2917 10.3344 45.4544 10.0046L48.593 3.64077L51.7351 10.0028C51.8979 10.3324 52.2124 10.5609 52.5762 10.6137L59.5985 11.6323L54.5186 16.5865Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.583 23.6389C30.4514 23.2346 30.1019 22.9399 29.6812 22.8789L25.6312 22.2916L23.8191 18.6224C23.6308 18.2413 23.2427 18 22.8176 18H22.8172C22.3921 18.0001 22.0039 18.2416 21.8158 18.6229L20.0056 22.293L15.9561 22.8825C15.5355 22.9437 15.186 23.2386 15.0546 23.6429C14.9234 24.0474 15.0329 24.4913 15.3375 24.788L18.2688 27.6436L17.5781 31.6772C17.5063 32.0962 17.6786 32.5198 18.0226 32.7695C18.2172 32.9107 18.4475 32.9826 18.6791 32.9826C18.857 32.9826 19.0355 32.9402 19.1989 32.8544L22.8207 30.9491L26.4434 32.8523C26.8198 33.05 27.2759 33.0169 27.6197 32.7669C27.9637 32.517 28.1358 32.0934 28.0638 31.6743L27.371 27.6413L30.3007 24.784C30.605 24.4872 30.7145 24.0433 30.583 23.6389ZM25.3907 26.4519C25.1277 26.7086 25.0075 27.0784 25.0698 27.4408L25.4789 29.822L23.34 28.6983C23.0146 28.5274 22.6258 28.5276 22.3004 28.6985L20.162 29.8235L20.5698 27.4418C20.6319 27.0793 20.5116 26.7097 20.2483 26.4531L18.5177 24.7671L20.9087 24.419C21.2725 24.3661 21.5869 24.1374 21.7495 23.8077L22.8182 21.6408L23.8882 23.8073C24.0509 24.1369 24.3655 24.3653 24.7293 24.4181L27.1205 24.7648L25.3907 26.4519Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5832 23.6429C81.4519 23.2386 81.1024 22.9437 80.6817 22.8825L76.6322 22.293L74.822 18.6229C74.6339 18.2416 74.2457 18.0001 73.8206 18H73.8202C73.3951 18 73.007 18.2413 72.8187 18.6224L71.0066 22.2916L66.9566 22.8789C66.536 22.9399 66.1864 23.2346 66.0548 23.6389C65.9233 24.0433 66.0327 24.4872 66.3371 24.784L69.2668 27.6413L68.574 31.6743C68.5021 32.0934 68.6742 32.5169 69.0181 32.7669C69.362 33.017 69.818 33.0501 70.1944 32.8523L73.8171 30.9491L77.4389 32.8544C77.6023 32.9403 77.7808 32.9827 77.9587 32.9827C78.1902 32.9827 78.4206 32.9109 78.6153 32.7694C78.9593 32.5196 79.1317 32.0961 79.0598 31.6771L78.3691 27.6435L81.3003 24.788C81.6047 24.4913 81.7144 24.0474 81.5832 23.6429ZM76.3896 26.4531C76.1263 26.7097 76.006 27.0794 76.0681 27.4418L76.4759 29.8235L74.3374 28.6985C74.1746 28.6129 73.9961 28.5701 73.8174 28.5701C73.6389 28.5701 73.4604 28.6129 73.298 28.6983L71.1591 29.822L71.5682 27.4408C71.6305 27.0783 71.5103 26.7086 71.2473 26.4519L69.5175 24.7648L71.9087 24.4181C72.2725 24.3653 72.5871 24.1369 72.7498 23.8073L73.8198 21.6408L74.8885 23.8077C75.0511 24.1374 75.3656 24.3661 75.7294 24.419L78.1202 24.7671L76.3896 26.4531Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7559 116.943V108.957",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7422 108.957V116.943",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9368 116.943H33.5636C30.4132 116.943 27.8594 119.497 27.8594 122.648C27.8594 124.223 29.1364 125.5 30.7115 125.5H67.789C69.3641 125.5 70.6411 124.223 70.6411 122.648C70.6411 119.497 68.0873 116.943 64.9368 116.943Z",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2914 42.4082H88.8944C93.0946 42.4082 96.5 45.8136 96.5 50.0138V101.352C96.5 105.552 93.0946 108.957 88.8944 108.957H9.60563C5.40542 108.957 2 105.552 2 101.352V68.0772",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 61.4223V50.0138C2 45.8136 5.40542 42.4082 9.60563 42.4082H25.2086",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6406 50.0137H85.0922C87.1933 50.0137 88.8951 51.7154 88.8951 53.8165V78.5348",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8942 85.1897V97.5489C88.8942 99.6499 87.1924 101.352 85.0914 101.352H13.4083C11.3072 101.352 9.60547 99.6499 9.60547 97.5489V53.8165C9.60547 51.7154 11.3072 50.0137 13.4083 50.0137H20.858",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 93.7441H25.8281",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 85.6641H25.8281",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8281 52.7096V66.5672C25.8281 68.9995 27.1469 71.2449 29.2748 72.423C42.5909 79.7957 55.9078 79.7953 69.2255 72.4228C71.3535 71.2447 72.6726 68.9991 72.6726 66.5668V52.709",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.552 62.6221L21.3761 50.3516C19.0022 49.0948 19.0022 45.6941 21.3761 44.4373L44.5543 32.1665C47.4922 30.6112 51.0098 30.6112 53.9476 32.1665L77.1254 44.4371C79.4993 45.6939 79.4993 49.0948 77.1252 50.3516L53.9456 62.6223C51.0075 64.1777 47.4901 64.1777 44.552 62.6221Z",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9949 83.7086V59.4206L48.5059 51.7246",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9938 93.7453C62.7658 93.7453 65.0129 91.4982 65.0129 88.7262C65.0129 85.9542 62.7658 83.707 59.9938 83.707C57.2218 83.707 54.9746 85.9542 54.9746 88.7262C54.9746 91.4982 57.2218 93.7453 59.9938 93.7453Z",
    stroke: "#424242",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerSuccess);
export default __webpack_public_path__ + "static/media/computer-success.6c0a0f6453eb43589ccb425ea4b737f6.svg";
export { ForwardRef as ReactComponent };